import * as React from "react";
const SvgAlertRedCircleIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 7, cy: 7, r: 6, fill: "#CC0300", stroke: "white", strokeWidth: 1.6 }));
export default SvgAlertRedCircleIcon;
